import { useState } from "react"
import { Button, Form } from "react-bootstrap";

export default function DateRangePicker(props: any) {
    const { setDates, dates } = props;
    const [fromDate, setFromDate] = useState(dates.from_date);
    const [toDate, setToDate] = useState(dates.to_date);
    const [errors, setErrors] = useState<any>({});

    function validateDates() {
        const errorMsgs: any = {};
        if (fromDate && toDate) {
            if (fromDate > toDate) {
                errorMsgs.from_date = "Should not be greater than To date.";
                errorMsgs.to_date = "Should not be less than From date.";
            }
            setErrors(errorMsgs)
        }
        if (!fromDate) {
            errorMsgs.from_date = "From date is required.";
        }
        if (!toDate) {
            errorMsgs.to_date = "To date is required.";
        }

        setErrors(errorMsgs)
        return Object.keys(errorMsgs).length
    };


    const handleSubmit = () => {
        if (!validateDates()) {
            setDates({ from_date: fromDate, to_date: toDate });
        }
    }

    return (
        <div className="serch-bar row">
            <div className="col-md-5 col-sm-12 d-flex align-items-baseline">
                <Form.Label className="fs-5" style={{minWidth: 55}}>From</Form.Label>
                <div className="w-100">
                    <Form.Control
                        type="date"
                        name="from_date"
                        id="from_date"
                        value={fromDate}
                        onChange={(e) => { setFromDate(e.target.value); setErrors({}) }}
                        isInvalid={errors.from_date}
                    />
                    <Form.Control.Feedback type="invalid">{errors.from_date}</Form.Control.Feedback>
                </div>
            </div>
            <div className="col-md-5 col-sm-12 d-flex align-items-baseline">
                <Form.Label className="fs-5" style={{minWidth: 55}}>To</Form.Label>
                <div className="w-100">
                    <Form.Control
                        type="date"
                        name="to_date"
                        id="to_date"
                        value={toDate}
                        onChange={(e) => { setToDate(e.target.value); setErrors({}) }}
                        isInvalid={errors.to_date}
                    />
                    <Form.Control.Feedback type="invalid">{errors.to_date}</Form.Control.Feedback>
                </div>
            </div>
            <div className="col-md-2 d-flex align-items-baseline">
                <Button variant="primary" size="sm" onClick={handleSubmit} className="mt-2 mt-md-0 ms-auto ms-md-0">
                    Get Chart
                </Button>
            </div>
        </div>
    )
}
